import type { ActivityKind } from "../hooks/useActivityFeed";

/**
 * Point values per activity kind.
 *
 * Weights reflect time, dedication, friction, and clinical impact.
 * Edit here to rebalance — Record<ActivityKind> enforces exhaustiveness.
 *
 * Axis scores (1–10): Time 25% + Dedication 30% + Impact 30% + Friction 15%
 * Scale: ~÷2 of raw scores to avoid inflated totals.
 */
export const ACTIVITY_POINTS: Record<ActivityKind, number> = {
  decodificar: 3,  // ~2 min quiz, zero upload, diagnostic base only
  criativo:    4,  // URL/file + context, ~5 min
  roteiro:     6,  // strategic input + AI processing, ~10 min
  simulador:   7,  // sustained roleplay session, ~15–30 min
  consulta:   10,  // record + upload + AI analysis, highest clinical impact
};

export function pointsFor(kind: ActivityKind): number {
  return ACTIVITY_POINTS[kind];
}
